import React, { useState, useEffect } from 'react'

export default function ClickToCopyButton({
  text,
  iconClass,
  successIconClass,
  successText,
  className = '',
  onError,
  resetDelay = 5000,
  ...props
}) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    if (!text) return

    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true)
      })
      .catch(err => {
        console.error('Failed to copy to clipboard')
        if (onError) onError(err)
      })
  }

  useEffect(() => {
    if (!copied) return

    const timer = setTimeout(() => {
      setCopied(false)
    }, resetDelay)

    return () => clearTimeout(timer)
  }, [copied, resetDelay])

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`${className} ${copied ? 'copied' : ''}`}
    >
      <i className={copied ? successIconClass : iconClass} />
      {copied && successText && (
        <span className="copy-button__success-text">
          {successText}
        </span>
      )}
    </button>
  )
}
